import type { TFunction } from 'i18next';

/** Translates a validation message key from a zod schema. */
export function fieldError(t: TFunction, message: string | undefined): string | undefined {
  if (!message) return undefined;
  return (t as unknown as (k: string) => string)(message);
}
